
import global from 'Core/global';
import Block from 'Mixins/Block';
import slider from 'Mixins/slider';

let component = null;

export default Block('component-banner', {
	fn: {
		setContentHeight() {

			const wrapper 		= component ? component[0] : null;
			const inner 		= wrapper ? component.child('.component-banner__inner')[0] : null;
			const content 		= wrapper ? component.child('.component-banner__content')[0] : null;
			const controller 	= wrapper ? component.child('.component-banner__controller')[0] : null;

			if (!wrapper && !inner && !content) {

				return false;

			}

			// Reset height
			wrapper.style.removeProperty('height');

			const innerHeight 		= inner.offsetHeight;
			const controllerHeight 	= controller && global.state.nav === 'mobile' ? controller.offsetHeight : 0;
			const contentHeight 	= content.offsetHeight + controllerHeight;
			const contentOffset 	= content.offsetTop;

			let extra = 0;

			if (contentOffset < 0) {

				extra = Math.abs(contentOffset) * 2;

			} else if (contentHeight > innerHeight) {

				// IE
				extra = contentHeight - innerHeight;

			}

			if (extra) {

				const newComponentHeight = wrapper.offsetHeight + extra;

				wrapper.style.height = newComponentHeight + 'px';

			} else {

				// Reset height
				wrapper.style.removeProperty('height');

			}

		}
	},
	onLoad(qComponent) {

		component = qComponent;

		const slides 		= qComponent.child('.swiper-slide');
		const controller 	= qComponent.child('.component-banner__controller');

		if (slides.length > 1) {

			slider.init(this.selector);

			controller.addClass('component-banner__controller--show');

		}

		this.fn.setContentHeight();

	},
	onResize() {

		this.fn.setContentHeight();

	}
});
